import { cx } from "class-variance-authority";
import Link from "next/link";

export const TagList = ({ tags, activeTags = [], classes }) => {
  const sortedData = tags?.data?.sort((a, b) => a.attributes.name.localeCompare(b.attributes.name));

  return (
    <div className={cx("flex flex-row flex-wrap w-full place-content-center", classes)}>
      {sortedData?.map((tag, ind) => {
        return (
          <Link
            key={tag?.attributes?.uid || ind}
            href={`/blog/category/${tag?.attributes?.uid}`}
          >
            <h2
              className={cx(
                "cursor-pointer px-5 py-2 mr-2.5 mt-7 text-sm text-center transition-all duration-300 ease-in-out w-fit rounded-sm box-border shadow-sm",
                activeTags?.includes(tag?.attributes?.uid)
                  ? "hover:bg-white bg-regal-purple text-white hover:text-regal-purple"
                  : "hover:bg-regal-purple bg-[#EDE0FF] text-black hover:text-white"
              )}
            >
              <span className="leading-4">{tag?.attributes?.name}</span>
            </h2>
          </Link>
        );
      })}
    </div>
  );
};
